import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logoAnna from '../img/La_psicologa.webp';
import logoAnnaSmall from '../img/La_psicologa_small.webp';

const links = [
  { to: '/', label: 'Home' },
  { to: '/chi-sono', label: 'Chi Sono' },
  { to: '/servizi', label: 'Servizi' },
  { to: '/contatti', label: 'Contatti' },
  { to: '/faq', label: 'FAQ' },
];

const Navbar = () => {
  const logoOptions = {
    large: { src: logoAnna, width: 1148, height: 353 },
    small: { src: logoAnnaSmall, width: 687, height: 282 },
  };
  const [isOpen, setIsOpen] = useState(false);
  const [logo, setLogo] = useState(logoOptions.large);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setLogo(window.innerWidth < 768 ? logoOptions.small : logoOptions.large);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <Link to="/" className="nav__logo" onClick={closeMenu}>
          <img
            src={logo.src}
            alt="La Psicologa Anna logo"
            loading="eager"
            decoding="async"
            width={logo.width}
            height={logo.height}
          />
        </Link>

        <button
          className={`nav__burger ${isOpen ? 'is-open' : ''}`}
          onClick={() => setIsOpen((v) => !v)}
          aria-label="Apri il menu"
          aria-expanded={isOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav__menu ${isOpen ? 'is-open' : ''}`}>
          <ul className="nav__links">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  onClick={closeMenu}
                  className={location.pathname === l.to ? 'is-active' : ''}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/prenota-appuntamento"
            className="btn btn--accent nav__cta"
            onClick={closeMenu}
          >
            Prenota
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
